"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeEdgeMapperToItemContextMap = exports.getDeviceContextFromNodeEdgeMapper = exports.isNodeEdgeMapperLike = exports.dehydrateNodeEdgeMapperToHydrateableSKMapped = exports.invertSkMapped = void 0;
const core_services_1 = require("@iotv/core-services");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const __1 = require("../../..");
const classDependentTypes_1 = require("../../../classDependentTypes");
const constants_1 = require("../../../constants");
const lambda_1 = require("../../../util/lambda");
const TypeHelpers_1 = require("../../../util/TypeHelpers");
const Device_1 = require("../../Device/Device");
const DeviceControl_1 = require("../../DeviceControl");
const debug = lambda_1.DEBUG_OVERRIDE || (lambda_1.NOT_LAMBDA && false);
const invertSkMapped = (skMapped) => {
    const rePkMapped = {};
    Object.entries(skMapped).forEach(([sk, pkMapped]) => {
        Object.entries(pkMapped).forEach(([pk, object]) => {
            if (!rePkMapped[pk]) {
                rePkMapped[pk] = {};
            }
            rePkMapped[pk][sk] = object;
        });
    });
    debug && console.log(`pkMapped in invert has ${Object.keys(rePkMapped).length} keys`);
    return rePkMapped;
};
exports.invertSkMapped = invertSkMapped;
const dehydrateNodeEdgeMapperToHydrateableSKMapped = (nem) => {
    const dehydrated = { ...nem };
    delete dehydrated.pkMapped;
    return dehydrated;
};
exports.dehydrateNodeEdgeMapperToHydrateableSKMapped = dehydrateNodeEdgeMapperToHydrateableSKMapped;
const isNodeEdgeMapperLike = (x) => {
    const y = x;
    let isValid = false;
    if (typeof y.pkMapped === 'object' && typeof y.skMapped === 'object') {
        isValid = true;
    }
    return isValid;
};
exports.isNodeEdgeMapperLike = isNodeEdgeMapperLike;
/** resolves group and customer where group is directly related to customer, used to disambiguate multple groups */
const getDeviceContextFromNodeEdgeMapper = ({ nodeEdgeMapper, device, deviceEnabledTypeIds }) => {
    let deviceContext = undefined;
    deviceContext = {
        device: new Device_1.Device(device),
    };
    const deviceConfigPseudoNodes = nodeEdgeMapper.getPseudoAttributes(device, DeviceControl_1.DeviceHistoryClassName);
    if (0 < deviceConfigPseudoNodes.length) {
        deviceContext.deviceConfig = new DeviceControl_1.DeviceConfig(deviceConfigPseudoNodes[0]);
    }
    const deviceHistoryPseudoNodes = nodeEdgeMapper.getPseudoAttributes(device, DeviceControl_1.DeviceHistoryClassName);
    if (0 < deviceHistoryPseudoNodes.length) {
        deviceContext.deviceHistory = new DeviceControl_1.DeviceHistory(deviceHistoryPseudoNodes[0]);
    }
    const { nodes: applicationServerNodes } = nodeEdgeMapper.getAdjacentNodesAndEdges(device, {
        objectTypeId: constants_1.NetworkApplicationServerClassName,
        adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
    });
    if (applicationServerNodes.length > 0) {
        deviceContext.applicationServer = applicationServerNodes[0];
        deviceContext.applicationServerDeviceEdge = (nodeEdgeMapper.getEdgeBetween(deviceContext.applicationServer, device) ??
            (0, TypeHelpers_1.getZombieEdge)(deviceContext.applicationServer, device, classDependentTypes_1.edgeTypeMatrix.LoRaWANApplicationServer.Device.networkApplicatonServer_has_device.edgeTypeId));
    }
    for (let deviceEnabledTypeId of deviceEnabledTypeIds) {
        const { nodes, edges } = nodeEdgeMapper.getAdjacentNodesAndEdges(device, { objectTypeId: deviceEnabledTypeId, adjacencyType: iotv_v3_types_1.AdjacentType.PARENT });
        if (nodes.length > 0) {
            const entity = nodes[0];
            const deviceEntityEdge = (nodeEdgeMapper.getEdgeBetween(entity, device) ?? (0, TypeHelpers_1.getZombieEdge)(entity, device));
            deviceContext.entity = entity;
            deviceContext.deviceEntityEdge = deviceEntityEdge;
            const { nodes: propertyNodes, edges: propertyEdges } = nodeEdgeMapper.getAdjacentNodesAndEdges(entity, {
                objectTypeId: 'Property',
                adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
            });
            if (propertyNodes.length > 0) {
                deviceContext.property = new __1.Property(propertyNodes[0]);
                deviceContext.entityPropertyEdge = (nodeEdgeMapper.getEdgeBetween(entity, deviceContext.property) ??
                    (0, TypeHelpers_1.getZombieEdge)(entity, deviceContext.property));
            }
            const { nodes: placeNodes, edges: placeEdges } = nodeEdgeMapper.getAdjacentNodesAndEdges(entity, {
                objectTypeId: 'Place',
                adjacencyType: iotv_v3_types_1.AdjacentType.CHILD,
            });
            if (placeNodes.length > 0) {
                deviceContext.place = new __1.Place(placeNodes[0]);
                deviceContext.entityPlaceEdge = (nodeEdgeMapper.getEdgeBetween(entity, deviceContext.place) ??
                    (0, TypeHelpers_1.getZombieEdge)(entity, deviceContext.place));
            }
            break;
        }
    }
    const groups = nodeEdgeMapper.getAdjacentNodesAndEdges(device, {
        objectTypeId: 'Group',
        adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
        edgeTypeId: classDependentTypes_1.edgeTypeMatrix.Group.Device.group_has_device.edgeTypeId,
        nodeFilters: [
            {
                setOperation: iotv_v3_types_1.LogicalOperatorType.AND,
                filters: [{ key: 'supportedType', predicate: iotv_v3_types_1.ComparisonType.EQUALS, value: 'Device' }],
            },
        ],
    });
    /** dev */
    debug && console.log('getDeviceContextFromNodeEdgeMapper nem types ', nodeEdgeMapper.getSummary());
    if (groups.nodes.length > 0) {
        for (let group of groups.nodes) {
            const customers = nodeEdgeMapper.getAdjacentNodesAndEdges(group, {
                objectTypeId: 'Customer',
                adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
                edgeTypeId: classDependentTypes_1.edgeTypeMatrix.Customer.Group.customer_has_group.edgeTypeId,
            });
            if (customers.nodes.length > 0) {
                const customer = customers.nodes[0];
                const customerGroupEdge = nodeEdgeMapper.getItem((0, TypeHelpers_1.getZombieEdge)(customer, group));
                const groupDeviceEdge = nodeEdgeMapper.getItem((0, TypeHelpers_1.getZombieEdge)(group, device));
                if (group && customer && customerGroupEdge && groupDeviceEdge) {
                    const assignable = {
                        device: new Device_1.Device(device),
                        group: group,
                        customer,
                        customerGroupEdge,
                        groupDeviceEdge,
                    };
                    if (!deviceContext) {
                        deviceContext = assignable;
                    }
                    else {
                        Object.assign(deviceContext, assignable);
                    }
                }
                break;
            }
        }
    }
    return deviceContext;
};
exports.getDeviceContextFromNodeEdgeMapper = getDeviceContextFromNodeEdgeMapper;
const nodeEdgeMapperToItemContextMap = ({ item: itemIn, nodeEdgeMapper, }) => {
    const res = { err: null, data: null };
    const item = nodeEdgeMapper.getItem(itemIn);
    if (item) {
        const outEs = [];
        const pseudoAttsFilter = (0, core_services_1.getRejectionBucketingFilter)({
            filter: (item) => (0, iotv_v3_types_1.isPseudoAttribute)(item),
            rejectionsBucket: outEs,
        });
        const pseudoAtts = nodeEdgeMapper.getChildEdges(item).filter(pseudoAttsFilter);
        const outVs = nodeEdgeMapper.getChildNodes(item);
        const inEs = nodeEdgeMapper.getParentEdges(item);
        const inVs = nodeEdgeMapper.getParentNodes(item);
        res.data = {
            item,
            inEs,
            inVs,
            outEs,
            outVs,
            pseudoAtts,
        };
    }
    else {
        res.err = new Error(`Failed to return target item`);
    }
    return res;
};
exports.nodeEdgeMapperToItemContextMap = nodeEdgeMapperToItemContextMap;
